import Header from "../components/Header";
import Footer from "../components/Footer";

export default function BankingFinance() {
  return (
    <>
      <Header />

      <section
        className="about-hero"
        style={{
          backgroundImage: "url('/assets/img/bankingfinance1.jpeg')",
        }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text">
          <h1>Banking & Project Finance</h1>
          <p>
            Expert financial structuring and advisory for business expansion,
            infrastructure projects, and long-term capital growth.
          </p>
        </div>
      </section>

      {/* ===== INTRO SECTION ===== */}
      <section className="bf-intro container">
        <h2>Banking, Funding & Project Finance</h2>
        <p className="container service-text">
          End-to-End support for preparing financial documents, raising capital
          and dealing with banks. We assist startups, MSMEs and growing
          businesses in securing the right funding at the right time.
        </p>
      </section>

      {/* ===== MAIN CONTENT CARDS ===== */}
      <div className="container bf-main">
        {/* CARD 1 */}
        <div className="bf-card">
          <h3>📊 CMA Data & Project Report Preparation</h3>
          <p>
            A professionally prepared CMA Report is essential for loan approval,
            renewal of limits and financial evaluation. We prepare
            banker-friendly CMA Reports including:
          </p>
          <ul>
            <li> Past, present & projected financial statements</li>
            <li> Fund flow & cash flow statements</li>
            <li> Ratio analysis & feasibility study</li>
            <li> Working capital assessment</li>
            <li> Profitability forecasting</li>
            <li> Loan justification & repayment capacity</li>
          </ul>
          <p>
            We also prepare detailed Project Reports for new ventures, expansion
            and diversification.
          </p>
        </div>

        {/* CARD 2 */}
        <div className="bf-card">
          <h3>💰 Working Capital & Term Loan Assistance</h3>
          <p>
            We help businesses obtain the right mix of funding through working
            capital, term loans and structured financing.
          </p>
          <ul>
            <li> Assessment of working capital requirement</li>
            <li> Preparation of loan applications & financial papers</li>
            <li> End-to-end coordination with banks</li>
            <li> Documentation for sanction & disbursement</li>
            <li> Renewal & enhancement of credit limits</li>
          </ul>
        </div>

        {/* CARD 3 */}
        <div className="bf-card">
          <h3>🏦 CC / OD, LC / BG & Bank Loan Syndication</h3>
          <p>
            We support businesses requiring advanced banking facilities and
            structured funding for trade, projects and capital needs.
          </p>
          <ul>
            <li> Cash Credit (CC) & Overdraft (OD) facilities</li>
            <li> Letter of Credit (LC) for imports & trade</li>
            <li> Bank Guarantees (BG) for contracts/tenders</li>
            <li> Syndicated loans with multiple banks</li>
            <li> Preparation of financial justifications</li>
          </ul>
        </div>

        {/* CARD 4 */}
        <div className="bf-card">
          <h3>📈 Credit Rating Improvement Advisory</h3>
          <p>
            We help companies strengthen internal & external credit ratings to
            secure cheaper loans and faster approvals.
          </p>
          <ul>
            <li> Improving financial ratios & documentation</li>
            <li> Optimizing capital structure</li>
            <li> Enhancing working capital cycle</li>
            <li> Preparing presentations for rating agencies</li>
          </ul>
        </div>

        {/* CARD 5 */}
        <div className="bf-card">
          <h3>🚀 Investor Pitch Decks for Fundraising</h3>
          <p>
            We design professional pitch decks tailored for angel investors, VCs
            and private equity firms.
          </p>
          <ul>
            <li> Business overview & problem statement</li>
            <li> Market research & competition study</li>
            <li> Business model & revenue strategy</li>
            <li> 5-year financial projections</li>
            <li> Funding needs & use of funds</li>
            <li> Growth roadmap & investor value</li>
          </ul>
        </div>
      </div>

      {/* ===== WHY CHOOSE US ===== */}
      {/* <section className="nri-highlight">
        <h2>Why Choose Our Banking & Funding Advisory?</h2>
        <ul className="bf-points">
          <li>Strong experience with public & private sector banks</li>
          <li>Expertise in financial analysis, ratios & funding structures</li>
          <li>End-to-end assistance from planning to final sanction</li>
          <li>Professional documentation trusted by bankers</li>
          <li>Strategic guidance to reduce interest cost</li>
          <li>Dedicated support for MSMEs, startups & corporates</li>
        </ul>
      </section> */}

      {/* <section className="bf-cta py-5 text-white text-center my-5">
        <div className="container">
          <h2 className="fw-bold mb-3">Need Help with Banking, Funding or Project Finance?</h2>
         <p>
              Our experts will help you prepare perfect documents, deal with
              banks and secure funding for your business.
            </p>
      
          <Link
            to="/contactus"
            className="apply-btn"
            style={{
              backgroundColor: "#65ad4b",
              color: "#fff",
              borderRadius: "8px",
            }}
            onClick={() => window.scrollTo({ top: 0 })}
          >
            Contact Us
          </Link>
        </div>
      </section> */}

      <Footer />
    </>
  );
}
